export default __webpack_public_path__ + "d474fc912e46780a35e04176bff17a58.svg";